import { appsModel } from "src/store/appsModel";
import { userModel } from "src/store/userModel";
import { authModel } from "src/store/authModel";
import { eventsModel } from "src/store/eventsModel";
import { configModel } from "src/store/configModel";
import { contentModel } from "src/store/contentModel";

// eslint-disable-next-line import/no-cycle
import api from "./api";

export const logout = async (userId: number) => {
    try {
      await api.post('/auth/logout', { userId });
      userModel.getState().reset();
      authModel.getState().reset();
      appsModel.getState().reset();
      configModel.getState().reset();
      eventsModel.getState().reset();
      contentModel.getState().clearAll();
      return true;
    } catch (error) {
      return false;
    }
  }
